import React from 'react';
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../_getjson';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import _Data1 from './_data1';
import _Data2 from './_data2';
import _accounttap from './_accounttap';
import { DropdownButton, MenuItem, Row, Grid, Col, Panel } from "react-bootstrap";
import axios from 'axios'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import Topbar from "../Components/Customtopbar/Topbar";
import SelectDatas from "./../PopUp/SelectData"
import Moment, { now } from 'moment';
import UseAutocomplete from '../Components/CustomInput/UseAutocomplete';
import FullScreenDialog from '../Components/CustomDialogs/Fullscreendialog';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Rechecked from './Components/Rechecked';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import InputData1 from './Components/Inputdata1/main';

require('./Savecustomer.css');
const listmenu = [["-", "-"]]
export default class Index extends React.Component {
    CalendarOnChange = (data) => {
        var today = new Date(data);
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd }
        if (mm < 10) { mm = '0' + mm }
        today = dd + '/' + mm + '/' + (yyyy + 543);
        return today;
    }
    constructor(props) {
        super(props);
        this.Code = React.createRef();
        this.arname = React.createRef();
        this.surname = React.createRef();
        this.houseno = React.createRef();
        this.groupno = React.createRef();
        this.housename = React.createRef();
        this.Telephone = React.createRef();
        this.canton_p = React.createRef();
        this.canton_i = React.createRef();
        this.canton_t = React.createRef();
        this.zip_code = React.createRef();
        this.Mail = React.createRef();
        this.Line_ID = React.createRef();
        this.facebook = React.createRef();
        this.state = {
            device_photos: [],
            data1: "",
            data2: "",
            data3: "",
            Code: '',
            alerttxt: 'กรุณาใส่ข้อมูล: ',
            CHLOOP: 0,
            loading: "none",
            dispay1: false,
            dispay2: false,
            _accounttap: false,
            SPRICELEVEL: "0",
            STAXTYPE: "1",
            sh1: 0,
            province: "",
            district: "",
            subdistrict: "",
            provinceName: "",
            districtName: "",
            TambonName: "",
            SBIRTHDAY: null,
            chk_onload: 0,
            ProvinceCode: "",
            sPersontype: "1",
            sCreditflag: "1",
            sCreditcode: "0",
            sCreditshare: "0",
            Accounttext: "",
            sTAXID: "",
            sAr_remark1: "",
            SMaingroup: "AR001",
            Ssubgroup: "",
            isLoading: false,
            openBackdrop: false,
            autoClose: 3600,
            color: "warning",
            messagealert: "",
            Amphoetxt: "",
            sexcode: "-",
            Occupation: "0",
            typeTaxnumberdefaultvalue: 1,// ค่าเริ่มต้นเงือนไขเลือกเลขประจำตัวผู้เสียภาษี

            // จังหวัดทั้งหมด
            provinceall: [],
            options: [],
            optionsProvince: [],
            optionsDistrict: [],
            optionsSubdistrict: [],
            // Confirmdialog
            open: false,
            description: "",
            Agreetxt: "ตกลง",
            Disagreetxt: "ยกเลิก",
            TapValue: "1"
        }
    }

    Getpszipcode = (Cantonicode) => {
        console.log(Cantonicode);
        if (Cantonicode) {
            let url = "CSWHEREABOUTS/Getpszipcode?top=100&Cantonicode=" + Cantonicode
            console.log("Getpszipcode", genURL(url));
            axios.get(genURL(url), { timeout: 6000 }).then(res => {
                if (res.data.length > 0) {
                    console.log(genURL("Getpszipcode res.data[0].CODE", res.data[0].CODE));
                    this.zip_code.current.value = res.data[0].CODE
                } else {
                    this.zip_code.current.value = ""
                }
            }).catch(error => {
                console.log(error);
            });
        }
    };
    Getpszipcode1 = (Code) => {
        console.log(Code);
        let url = "CSWHEREABOUTS/Getpszipcode?top=100&Code=" + (Code ? Code : "")
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 6000 }).then(res => {
            if (res.data.length > 0) {
                this.zip_code.current.value = res.data[0].CODE
            } else {
                this.zip_code.current.value = ""
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "รหัสไปรษณีย์ไม่ถูกต้อง" })
            }
        }).catch(error => {
            console.log(error);
        });
    };

    _handleSearchall = () => {
        let urlProvince = "CSWHEREABOUTS/Getprovinceall?top=100";
        console.log(genURL(urlProvince));
        var elementProvince = [];

        axios.get(genURL(urlProvince), { timeout: 6000 }).then(res => {
            if (res !== "error") {
                this.setState({ provinceall: res.data })
                for (let index = 0; index < res.data.length; index++) {
                    elementProvince.push({ CODE: res.data[index].CODE, MYNAMETH: res.data[index].MYNAMETH })
                }
            }
        }).catch(error => {
            console.log(error);
        }).finally(_ => {
            this.setState({
                optionsProvince: elementProvince,
            });
        });
    };
    _handleSearch = async (chkfocus) => {
        this.setState({ isLoading: true });
        switch (chkfocus) {
            case "province":
                let row = this.state.provinceall
                var element0 = [];
                for (let index = 0; index < row.length; index++) {
                    element0.push(row[index].CODE + " | " + row[index].MYNAMETH);
                }
                this.setState({
                    options: element0,
                    isLoading: false
                });
                break;
            case "district":
                if (this.state.province) {
                    var element1 = [];
                    let urlAmphoe = "CSWHEREABOUTS/Getdistrictall?Provincecode=" + this.state.province;
                    console.log("urlAmphoe", genURL(urlAmphoe));
                    await axios.get(genURL(urlAmphoe), { timeout: 6000 }).then(res => {
                        if (res.data.length > 0) {
                            for (let index = 0; index < res.data.length; index++) {
                                element1.push(res.data[index].CODE + " | " + res.data[index].MYNAMETH);
                            }
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                    this.setState({
                        isLoading: false,
                        options: element1
                    });
                }
                break;
            case "subdistrict":
                if (this.state.district) {
                    let urlTambon = "CSWHEREABOUTS/Getsubdistrictall?Districtcode=" + this.state.district;
                    console.log(genURL(urlTambon));
                    axios.get(genURL(urlTambon), { timeout: 6000 }).then(res => {
                        if (res !== "error") {
                            var element2 = [];
                            for (let index = 0; index < res.data.length; index++) {
                                element2.push(res.data[index].CODE + " | " + res.data[index].MYNAMETH);
                            }
                            this.setState({
                                isLoading: false,
                                options: element2
                            });
                        }
                    }).catch(error => {
                        console.log(error);
                    })
                }
                break;
            default: break;
        }
    };
    ResetThisPage = (e) => {
        window.location.replace("/Savecustomer");
    }
    cstate = (e) => {
        this.setState({ data1: "" });
        this.setState({ data2: "" });
        this.setState({ data3: "" });
    }
    cancelCourse = () => {
        window.location.reload();
    }
    clearform = () => {
        this.setState({ CSubgroup1: "" });

    }
    SelectSetData = (type, data) => {
        console.log(data);
        if (data !== "") {
            // var data2 = data.split("|")
            switch (type) {
                case "Sex":
                    this.setState({ sexcode: data })
                    break;
                case "Occupation":
                    this.setState({ Occupation: data })
                    break;
                case "_prefix":
                    this.setState({ prefixcode: data })
                    if (data === '1' || data === '6') {
                        this.setState({ sexcode: 'ชาย' })
                    } else if (data === '2' || data === '3') {
                        this.setState({ sexcode: 'หญิง' })
                    } else {
                        this.setState({ sexcode: '-' })
                    }
                    break;
                default:
                    break;
            }
        }
    }
    onKey = (type, value) => {
        switch (type) {
            case "Code": this.setState({ Code: value.target.value }); break;
            case "Oldcode": this.setState({ Oldcode: value.target.value }); break;
            case "Nameth": this.setState({ Nameth: value.target.value }); break;
            case "Addressth": this.setState({ Addressth: value.target.value }); break;
            case "Telephone": this.setState({ Telephone: value.target.value }); break;
            case "Faxno": this.setState({ Faxno: value.target.value }); break;

        }

    }

    componentDidMount() {

        var url = "CSRIGHT/FRM?user=" + localStorage.getItem('Username') + "&syscode=AR&menuid=40101";
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data === 0) {
                this.dialog.show({
                    title: 'แจ้งเตือน : ',
                    body: 'กรุณาตรวจสอบสิทธิ์การใช้งาน',
                    actions: [
                        /* Dialog.OKAction(() => {
                        }) */
                    ],
                    bsSize: 'small',
                    onHide: (dialog) => {
                        //dialog.hide()
                    }
                })
                return;
            }
        }).catch(error => {
            console.log(error);
        });

        this._handleSearchall()
    }
    ReDate = (Date) => {
        let redate = Date ? Moment(Date, "YYYY-MM-DD").add(543, "year").format('DD/MM/YYYY') : ""
        return redate
    };
    checkAddress = async (name, code) => {
        if (name === "province") {
            console.log("province checkAddress", this.state.optionsProvince);
            if (code) {
                let row = this.state.optionsProvince
                for (let i = 0; i < row.length; i++) {
                    if (code === row[i].CODE) {
                        this.setState({
                            province: row[i].CODE,
                            provinceName: row[i].MYNAMETH
                        });

                    }
                }
            } else {
                this.setState({
                    province: "",
                    provinceName: ""
                })

            }
        }
        if (name === "district") {
            if (code) {
                let row = this.state.optionsDistrict
                if (row.length > 0) {
                    for (let i = 0; i < row.length; i++) {
                        if (code === row[i].CODE) {
                            this.setState({
                                district: row[i].CODE,
                                districtName: row[i].MYNAMETH
                            });

                        }
                    }
                } else {
                    let url = "CSWHEREABOUTS/Getdistrictcode?Provincecode=" + code
                    await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                        for (let i = 0; i < res.data.length; i++) {
                            if (code === res.data[i].CODE) {
                                this.setState({
                                    district: res.data[i].CODE,
                                    districtName: res.data[i].MYNAMETH
                                });

                            }
                        }
                    })
                }
            } else {
                this.setState({
                    district: "",
                    districtName: ""
                })
            }

        }
        if (name === "subdistrict") {
            if (code) {
                let row = this.state.optionsSubdistrict
                if (row.length > 0) {
                    for (let i = 0; i < row.length; i++) {
                        if (code === row[i].CODE) {
                            this.setState({
                                subdistrict: row[i].CODE,
                                subdistrictName: row[i].MYNAMETH
                            });

                        }
                    }
                } else {
                    let url = "CSWHEREABOUTS/Getsubdistrictcode?Districtcode=" + code
                    await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                        for (let i = 0; i < res.data.length; i++) {
                            if (code === res.data[i].CODE) {
                                this.setState({
                                    subdistrict: res.data[i].CODE,
                                    subdistrictName: res.data[i].MYNAMETH
                                });

                            }
                        }
                    })
                }
            } else {
                this.setState({
                    subdistrict: "",
                    subdistrictName: ""
                })
            }
        }
    }
    subfrefix = async (code) => {
        var frefix = "222"
        if (code) {
            var url = "PSPREFIX/CODE?code=" + code;
            await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                frefix = res.data[0].MYNAMETH
            }).catch(error => {
                console.log(error);
            });
        }
        return frefix
    }
    onKeyDown = (e) => {
        if (e.key === "Enter") {
            this.onKeyPressValue("Code")
        }
    };
    onKeyPressValue = async (e) => {
        if (e === "Code") {
            this.setState({ chk_onload: 1 });
            // this.nameInput2.current.focus();  
            switch (e) {
                case 'Code':
                    if (this.Code.current.value.length > 0) {
                        var url = "CSAR/ARCode?arcode=" + this.Code.current.value + "&user=" + localStorage.getItem("Username");
                        console.log(genURL(url));
                        await axios.get(genURL(url), { timeout: 5600 }).then(async (res) => {
                            console.log("res get ardata", res);
                            if (res.data.length > 0) {
                                var arname = ""
                                try {
                                    await this.subfrefix(res.data[0].Prefis).then(data => {
                                        arname = res.data[0].Arname.split(data)
                                        console.log(arname);
                                        console.log(arname[1] == undefined ? arname[0] : arname[1])
                                    })
                                } catch (error) {
                                    console.log("res get ardata error", error);
                                }

                                this.setState({ sh: 1 })
                                this.setState({ prefixcode: res.data[0].Prefis })
                                this.arname.current.value = res.data[0].Arname
                                //arname[1] == undefined ? arname[0] : arname[1];
                                this.surname.current.value = res.data[0].Surname;
                                this.setState({ sexcode: (res.data[0].Sex === "ชาย" || res.data[0].Sex === "หญิง" ? res.data[0].Sex : '-') })
                                this.houseno.current.value = res.data[0].HouseNo;
                                this.groupno.current.value = res.data[0].GroupNo;
                                this.housename.current.value = res.data[0].HouseName;
                                this.Telephone.current.value = res.data[0].TELEPHONE;

                                this.checkAddress("province", res.data[0].Canton_P)
                                this.checkAddress("district", res.data[0].Canton_I)
                                this.checkAddress("subdistrict", res.data[0].Canton_T)
                                this.zip_code.current.value = res.data[0].Zip_Code;

                                this.Mail.current.value = res.data[0].Mail;
                                this.Line_ID.current.value = res.data[0].Line_ID;
                                this.facebook.current.value = res.data[0].facebook;
                                this.setState({ Occupation: res.data[0].Occupation })
                                this.setState({ SMaingroup: res.data[0].MAINGROUP })
                                this.setState({ Ssubgroup: res.data[0].SUBGROUP1 })
                                this.setState({ SPRICELEVEL: res.data[0].PRICELEVEL })
                                this.setState({ SBIRTHDAY: res.data[0].BIRTHDAY ? this.ReDate(res.data[0].BIRTHDAY) : null })
                                this.setState({ STAXTYPE: res.data[0].TAXTYPE })
                                this.setState({ sPersontype: String(res.data[0].PERSONTYPE) })
                                this.setState({ sCreditflag: String(res.data[0].CREDITFLAG) })
                                this.setState({ sCreditcode: res.data[0].CREDITCODE })
                                this.setState({ sCreditshare: String(res.data[0].CREDITSHARE) })
                                this.setState({ Accounttext: res.data[0].ACCOUNTCODE })
                                this.setState({ sTAXID: res.data[0].TAXID })
                                this.setState({ sAr_remark1: res.data[0].AR_REMARK1 })
                                //this.componentDidMount();
                                this.cstate();
                            } else {
                                this.setState(
                                    {
                                        open: true,
                                        description: "ไม่พบข้อมูล คุณต้องการล้างข้อมูลหน้าจอหรือไม่"
                                    }
                                )
                            }

                        }).catch(error => {
                            console.log(error);
                        });
                    }
                    break;
                case 'Nameth': this.nameInput3.current.focus(); break;
                case 'Addressth': this.nameInput4.current.focus(); break;
            }


        }
    }
    _handleImageChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result
            });
        }
        reader.readAsDataURL(file)
    }
    Getdata = (from, value) => {

        switch (from) {
            case "data1":

                if (value[0] === "Maingroup") {
                    this.setState({ SMaingroup: value[1] });
                }
                if (value[0] === "Subgroup1") {
                    this.setState({ Ssubgroup: value[1] });
                }
                break;
            case "data2":
                let subdata2 = value.split("|")
                if (subdata2[0] === "Pricelevel") {
                    this.setState({ SPRICELEVEL: subdata2[1] });
                }
                if (subdata2[0] === "Calendar1") {
                    this.setState({ SBIRTHDAY: subdata2[1] === "null" ? null : subdata2[1] });
                }
                if (subdata2[0] === "PriceType") {
                    this.setState({ STAXTYPE: subdata2[1] });
                }
                break;
            case "data3":
                let subdata3 = value.split("|")
                if (subdata3[0] === "Persontype") {
                    this.setState({ sPersontype: subdata3[1] });
                }
                if (subdata3[0] === "Creditflag") {
                    this.setState({ sCreditflag: subdata3[1] });
                }
                if (subdata3[0] === "Creditcode") {
                    this.setState({ sCreditcode: subdata3[1] });
                }
                if (subdata3[0] === "Creditshare") {
                    this.setState({ sCreditshare: subdata3[1] });
                }
                if (subdata3[0] === "Accountcode") {
                    this.setState({ Accounttext: subdata3[1] });
                }
                if (subdata3[0] === "Taxid") {

                    this.setState({ sTAXID: subdata3[1] });
                }
                if (subdata3[0] === "Arremark1") {
                    this.setState({ sAr_remark1: subdata3[1] });
                }
                break;
            default:
                break;
        }
    }

    saveData = async () => {




        var chkprefixname = ""
        await axios.get(genURL('PSPREFIX/ALL?MFLAG=1&code=' + this.state.prefixcode), { timeout: 3600 }).then(res => {
            chkprefixname = res.data[0].MYNAMETH ? res.data[0].MYNAMETH : ""
        })
        var url = "CSAR/ARCode?arcode=" + this.Code.current.value + "&user=" + localStorage.getItem("Username");
        var update = false
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            update = (res.data.length > 0 ? true : false)
        })
        let hous = ""
        if (this.housename.current.value && this.housename.current.value !== "-") {
            hous = " บ้าน" + this.housename.current.value
        }
        let ADDRESStext = "เลขที่ " + this.houseno.current.value + " หมู่ " + this.groupno.current.value + hous + " " + this.state.subdistrictName +
            " " + this.state.districtName + " " + this.state.provinceName + " " + this.zip_code.current.value
        const parameter = new URLSearchParams();
        parameter.append("CREATEUSER", localStorage.getItem('Username'));
        parameter.append("CODE", this.Code.current.value);
        parameter.append("Prefis", this.state.prefixcode);
        parameter.append("Prefisname", chkprefixname);
        parameter.append("ARNAME", this.arname.current.value);
        parameter.append("Surname", this.surname.current.value);
        parameter.append("Sex", this.state.sexcode);
        //ที่อยู่
        parameter.append("ADDRESS", ADDRESStext);
        parameter.append("HouseNo", this.houseno.current.value);
        parameter.append("Village", this.groupno.current.value);
        parameter.append("HouseName", this.housename.current.value);
        parameter.append("TELEPHONE", this.Telephone.current.value);
        parameter.append("Canton_P", this.state.province);
        parameter.append("Canton_I", this.state.district);
        parameter.append("Canton_T", this.state.subdistrict);
        parameter.append("Zip_Code", this.zip_code.current.value);

        parameter.append("Mail", this.Mail.current.value);
        parameter.append("Line_ID", this.Line_ID.current.value);
        parameter.append("facebook", this.facebook.current.value);
        parameter.append("Occupation", this.state.Occupation);
        //ข้อมูล1
        parameter.append("MAINGROUP", this.state.SMaingroup);
        parameter.append("SUBGROUP1", this.state.Ssubgroup);
        //ข้อมูล2
        parameter.append("PRICELEVEL", this.state.SPRICELEVEL);
        parameter.append("BIRTHDAY", this.state.SBIRTHDAY ? this.state.SBIRTHDAY : "");
        parameter.append("TAXTYPE", this.state.STAXTYPE);
        //ข้อมูล3
        parameter.append("PERSONTYPE", this.state.sPersontype);
        parameter.append("CREDITFLAG", this.state.sCreditflag);
        parameter.append("CREDITCODE", this.state.sCreditcode);
        parameter.append("CREDITSHARE", this.state.sCreditshare);
        parameter.append("ACCOUNTCODE", this.state.Accounttext);
        parameter.append("TAXID", this.state.sTAXID);
        parameter.append("AR_REMARK1", this.state.sAr_remark1);

        /* CURRENCYCODE */
        parameter.append("CURRENCYCODE", "TH");
        var Uststus = true;
        for (var pair of parameter.entries()) {
            console.log(pair);
            if (pair[1] === "undefined") {
                pair[1] = "";
            }
            if (pair[0] === "CODE" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" })
                this.Code.current.focus()
                return;
            }
            if (pair[0] === "Prefis" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกคำนำหน้า" })
                return;
            }
            if (pair[0] === "ARNAME" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกชื่อลูกค้า" })
                this.arname.current.focus();
                return;
            }

            if (pair[0] === "Sex" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกเพศลูกค้า" })
                return;
            }
            if (pair[0] === "HouseNo" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกบ้านเลขที่ลูกค้า" })
                this.houseno.current.focus();
                return;
            }
            if (pair[0] === "Village" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกเลขที่หมู่ลูกค้า" })
                this.groupno.current.focus();
                return;
            }
            if (pair[0] === "province" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกจังหวัด" })
                return;
            }

            if (pair[0] === "district" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกอำเภอ" })
                return;
            }
            if (pair[0] === "subdistrict" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกตำบล" })
                return;
            }
            if (pair[0] === "Zip_Code" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกรหัสไปรษณีย์" })
                this.zip_code.current.focus();
                return;
            }

            if (pair[0] === "Occupation" && (pair[1] === "" || pair[1] === "0")) {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกอาชีพ" })
                return;
            }

            if (pair[0] === "MAINGROUP" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกกลุ่มลูกค้าหลัก(ข้อมูล1)" })
                return;
            }
            if (pair[0] === "CREDITCODE" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกรหัสเครดิต(บัญชี)" })
                return;
            }
            if (pair[0] === "ACCOUNTCODE" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกรหัสบัญชีลูกค้ารายตัว(บัญชี)" })
                return;
            }
            if (pair[0] === "TAXID" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกเลขประจำตัวผู้เสียภาษี(บัญชี)" })
                return;
            }
            

            if (pair[0] === "BIRTHDAY" && (pair[1] === "" || pair[1] === "null" || typeof pair[1] === "undefined")) {

                console.log("pair[0]", pair[0], " pair[1]", pair[1]);
                
                Uststus = false;
                this.setState({ opensnackbar: true, color: "warning", icon: ErrorIcon, messagealert: "กรุณากรอกวันเกิด" })
                return;
            }
        }

        // console.log("typeTaxnumberdefaultvalue check", this.state.typeTaxnumberdefaultvalue);
        //  console.log("typeTaxnumberdefaultvalue checkif", this.Code.current.value !== this.state.sTAXID && this.state.typeTaxnumberdefaultvalue === "1");

        if (this.Code.current.value !== this.state.sTAXID && this.state.typeTaxnumberdefaultvalue.toString() === "1") {
            Uststus = false;
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "เลขประจำตัวผู้เสียภาษีไม่ตรงกับรหัสลูกค้า กรุณาตรวจสอบใหม่อีกครั้ง" })
            return;
        }

        console.log(update);
        if (Uststus === true) {
            this.setState({ openBackdrop: true })
            var url = "CSAR/Save?";
            var message = "บันทึกสำเร็จ"
            var errmessage = "บันทึกไม่สำเร็จ"
            if (update === true) {
                message = "อัพเดทสำเร็จ"
                errmessage = "อัพเดทไม่สำเร็จ"
                url = "CSAR/ARUpdate?"
            }
            //  console.log(genpostURLTEST(url));
            await axios.post(genpostURL(url), parameter).then(res => {
                // await axios.post(genpostURLTEST("/ARUpdate?"), parameter).then(res => {
                console.log(res);
                if (res.data === "1") {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "success" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: message })
                    setTimeout(() => {
                        this.ResetThisPage();
                        this.setState({ openBackdrop: false })
                    }, 1000);
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: errmessage })
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
                this.setState({ openBackdrop: false })
            });
        }

    }
    CHLOOP = (e) => {
        var i = this.state.CHLOOP + 1;
        this.setState({ CHLOOP: i });

    }
    ReadIDCard = async () => {
        const filters = [
            { vendorId: 0x058F, productId: 0x9540 }
        ];

        navigator.usb.getDevices()
            .then(devices => {
                if (devices.length) {
                    console.log("Total devices: " + devices.length);
                }
            });
    }
    onClickTopbar = (e) => {
        console.log(e);
        switch (e) {
            case "save":
                this.saveData()
                break;
            case "new":
                this.ResetThisPage()
                break;
            case "print":
                console.log("print");
                break;
            case "search":
                console.log("search");
                this.setState({ typeFullScreenDialog: e })
                //open
                this.setState({ openFullScreenDialog: true })
                //title
                this.setState({ titleFullScreenDialog: "ค้นหาข้อมูลลูกค้า" })
                break;
            default:
                break;
        }
    }
    chkzip_code = (e) => {
        if (e.target.value) {
            this.Getpszipcode1(e.target.value)
        }
    }
    // new 23-6-65

    setvalue = async (val, type) => {
        if (type === 'province') {
            await this.setState({
                province: val,
                provinceName: ""
            })
            this.checkAddress(type, val)
            await this.loadAmphoe(val)

        } else if (type === 'district') {
            await this.setState({
                district: val,
                districtName: ""
            })
            this.checkAddress(type, val)
            await this.loadsubdistrict(val)
            await this.Getpszipcode(val)
        } else if (type === 'subdistrict') {
            await this.setState({
                subdistrict: val,
                subdistrictName: ""
            })
            this.checkAddress(type, val)
        }
    }

    loadAmphoe = async (val) => {
        let url = "CSWHEREABOUTS/Getdistrictcode?Provincecode=" + val
        console.log(genURL(url));
        let elementAmphoe = []
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            console.log("resCSWHEREABOUTS", res.data);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    elementAmphoe.push({ CODE: res.data[index].CODE, MYNAMETH: res.data[index].MYNAMETH })
                }
            }
        }).catch(error => {
            console.log(error);
        }).finally(_ => { this.setState({ optionsDistrict: elementAmphoe }) });
    }
    loadsubdistrict = async (val) => {
        let url = "CSWHEREABOUTS/Getsubdistrictcode?Districtcode=" + val
        console.log(genURL(url));
        let elementsubdistrict = []
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {

            console.log("resCSWHEREABOUTS", res.data);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    elementsubdistrict.push({ CODE: res.data[index].CODE, MYNAMETH: res.data[index].MYNAMETH })
                }
            }
        }).catch(error => {
            console.log(error);
        }).finally(_ => { this.setState({ optionsSubdistrict: elementsubdistrict }) });
    }
    onUseAutocompleteactivate = async (val) => {
        console.log("onUseAutocompleteactivate", val, "this.state.province", this.state.province);
        if (val === "district") {
            if (this.state.province === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกจังหวัดก่อนครับ" })
                return
            } else {
                this.loadAmphoe(this.state.province)
            }
        }
        if (val === "subdistrict") {
            if (this.state.district === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกอำเภอก่อนครับ" })
                return
            } else {
                this.loadsubdistrict(this.state.district)
            }
        }
    }
    // end edit 23-6-65
    arcodeonBlur = (e) => {
        console.log("arcodeonChange", e.target.value);
        this.setState({ sTAXID: e.target.value })
    }

    CloseDialog = (e) => {
        this.setState({ openFullScreenDialog: e })
    }

    async _reCHK(e) {
        await this.setState({ openFullScreenDialog: false })
        await console.log("_reCHK", e)
        await this.recheckData(e)
    }
    async recheckData(e) {
        console.log("recheckData", e);
        var url = "CSAR/ARCode?arcode=" + e[0].arCode + "&user=" + localStorage.getItem("Username");
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 5600 }).then(async (res) => {
            console.log("res get ardata", res);
            if (res.data.length > 0) {
                this.Code.current.value = res.data[0].CODE;
                console.log("res.data[0].Prefis", res.data[0].Prefis);
                var arname = ""
                try {
                    await this.subfrefix(res.data[0].Prefis).then(data => {
                        arname = res.data[0].Arname.split(data)
                        console.log(arname);
                        console.log(arname[1] == undefined ? arname[0] : arname[1])
                    })
                } catch (error) {
                    console.log("res get ardata error", error);
                }

                this.setState({ sh: 1 })
                this.setState({ prefixcode: res.data[0].Prefis })
                this.arname.current.value = res.data[0].Arname
                //arname[1] == undefined ? arname[0] : arname[1];
                this.surname.current.value = res.data[0].Surname;
                this.setState({ sexcode: (res.data[0].Sex === "ชาย" || res.data[0].Sex === "หญิง" ? res.data[0].Sex : '-') })
                this.houseno.current.value = res.data[0].HouseNo;
                this.groupno.current.value = res.data[0].GroupNo;
                this.housename.current.value = res.data[0].HouseName;
                this.Telephone.current.value = res.data[0].TELEPHONE;
                this.checkAddress("province", res.data[0].Canton_P)
                this.checkAddress("district", res.data[0].Canton_I)
                this.checkAddress("subdistrict", res.data[0].Canton_T)
                this.zip_code.current.value = res.data[0].Zip_Code;

                this.Mail.current.value = res.data[0].Mail;
                this.Line_ID.current.value = res.data[0].Line_ID;
                this.facebook.current.value = res.data[0].facebook;
                this.setState({ Occupation: res.data[0].Occupation })
                this.setState({ SMaingroup: res.data[0].MAINGROUP })
                this.setState({ Ssubgroup: res.data[0].SUBGROUP1 })
                this.setState({ SPRICELEVEL: res.data[0].PRICELEVEL })
                this.setState({ SBIRTHDAY: res.data[0].BIRTHDAY ? this.ReDate(res.data[0].BIRTHDAY) : null })
                this.setState({ STAXTYPE: res.data[0].TAXTYPE })
                this.setState({ sPersontype: String(res.data[0].PERSONTYPE) })
                this.setState({ sCreditflag: String(res.data[0].CREDITFLAG) })
                this.setState({ sCreditcode: res.data[0].CREDITCODE })
                this.setState({ sCreditshare: String(res.data[0].CREDITSHARE) })
                this.setState({ Accounttext: res.data[0].ACCOUNTCODE })
                this.setState({ sTAXID: res.data[0].TAXID })
                this.setState({ sAr_remark1: res.data[0].AR_REMARK1 })
                //this.componentDidMount();
                this.cstate();
            } else {
                this.setState(
                    {
                        open: true,
                        description: "ไม่พบข้อมูล คุณต้องการล้างข้อมูลหน้าจอหรือไม่"
                    }
                )
            }

        }).catch(error => {
            console.log(error);
        });
    }

    handleChange = (event, newValue) => {
        console.log("event", event)
        console.log("newValue", newValue)
        this.setState({ TapValue: newValue });
    };

    render() {
        let { imagePreviewUrl } = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = (<img src={imagePreviewUrl} height="100%" width="100%" />);
        } else {
            $imagePreview = (<img src="https://images.onlinelabels.com/images/clip-art/dagobert83/dagobert83_female_user_icon.png" height="100%" width="100%" />);
        }

        return (
            <div className="PSApp" >

                <FullScreenDialog open={this.state.openFullScreenDialog} title={this.state.titleFullScreenDialog} CloseDialog={e => this.CloseDialog(e)}>
                    <Rechecked Dataselect={e => this._reCHK(e)} />
                </FullScreenDialog>
                <Topbar
                    listmenu={listmenu}
                    title="บันทึกข้อมูลลูกค้า"
                    onClick={e => this.onClickTopbar(e)}
                />
                <div className="PSAppfrom">
                    <Grid>
                        <Row className="show-grid">
                        </Row>
                        <Row className="show-grid">
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon"> รหัสลูกค้า </span>
                                        <input id="Code" type="text" className="form-control " ref={this.Code} name="Code"
                                            onKeyDown={this.onKeyDown}  /* onBlur={this.onKeyPressValue.bind(null, "Code")} */

                                            onBlur={this.arcodeonBlur} />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <SelectDatas
                                            origin="_prefix"  // คำนำหน้า
                                            valueSelect={e => this.SelectSetData("_prefix", e)} // รับค่ากลับ
                                            title="คำนำหน้า"
                                            defaultselect={this.state.prefixcode}// ค่าเริ่มต้นของ คำนำหน้า
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon"> ชื่อลูกค้า </span>
                                        <input id="arname" type="text" className="form-control " ref={this.arname} name="arname" />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon"> นามสกุล </span>
                                        <input id="surname" type="text" className="form-control " ref={this.surname} name="surname" />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <SelectDatas
                                            origin="Sex"  // คำนำหน้า
                                            valueSelect={e => this.SelectSetData("Sex", e)} // รับค่ากลับ
                                            title="เพศ"
                                            defaultselect={this.state.sexcode}// ค่าเริ่มต้นของ คำนำหน้า
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon"> โทรศัพท์ </span>
                                        <input id="Telephone" type="text" className="form-control " name="Telephone" ref={this.Telephone}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="show-grid">
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon width">Email </span>
                                        <input id="Mail" type="text" className="form-control width1 " name="Mail" ref={this.Mail} />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon width">LineID </span>
                                        <input id="Line_ID" type="text" className="form-control width1 " name="Line_ID" ref={this.Line_ID} />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon width">Facbook </span>
                                        <input id="facebook" type="text" className="form-control width1 " name="facebook" ref={this.facebook} />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="show-grid">
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon"> บ้านเลขที่ </span>
                                        <input id="houseno" type="text" className="form-control " ref={this.houseno} name="houseno" />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon"> หมู่ที่ </span>
                                        <input id="groupno" type="text" className="form-control " ref={this.groupno} name="groupno" />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon"> ชื่อหมู่บ้าน </span>
                                        <input id="housename" type="text" className="form-control " ref={this.housename} name="housename" />
                                    </div>
                                </div>
                            </Col>

                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <UseAutocomplete title="จังหวัด" id="province"
                                            datalist={this.state.optionsProvince}
                                            valueReturn={e => this.setvalue(e, "province")}
                                            activate={e => console.log(e)}
                                            placeholder={this.state.provinceName}
                                        />
                                    </div>
                                </div>
                            </Col>


                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <UseAutocomplete title="อำเภอ" id="district"
                                            datalist={this.state.optionsDistrict}
                                            valueReturn={e => this.setvalue(e, "district")}
                                            activate={e => this.onUseAutocompleteactivate("district")}
                                            placeholder={this.state.districtName}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <UseAutocomplete title="ตำบล" id="subdistrict"
                                            datalist={this.state.optionsSubdistrict}
                                            valueReturn={e => this.setvalue(e, "subdistrict")}
                                            activate={e => this.onUseAutocompleteactivate("subdistrict")}
                                            placeholder={this.state.subdistrictName}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span className="input-group-addon"> รหัสไปรษณีย์ </span>
                                        <input id="zip_code" name='zip_code' type="number" className="form-control " ref={this.zip_code}
                                            onBlur={(e) => this.chkzip_code(e)} />
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <SelectDatas
                                            origin="Occupation"  // อาชีพ
                                            valueSelect={e => this.SelectSetData("Occupation", e)} // รับค่ากลับ
                                            title="อาชีพ"
                                            defaultselect={this.state.Occupation}// ค่าเริ่มต้นของ คำนำหน้า
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </div>

                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={this.state.TapValue}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={this.handleChange} aria-label="lab API tabs example">
                                <Tab label="ข้อมูล1" value="1" />
                                <Tab label="ข้อมูล2" value="2" />
                                <Tab label="บัญชี" value="3" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <InputData1 MainGroup={this.state.SMaingroup} SubGroup={this.state.Ssubgroup} GetData={this.Getdata} />
                        </TabPanel>
                        <TabPanel value="2">

                            <_Data2 Getdata={this.Getdata}
                                p2_1={this.state.SPRICELEVEL}
                                p2_2={this.state.SBIRTHDAY}
                                p2_3={this.state.STAXTYPE} />
                        </TabPanel>
                        <TabPanel value="3">

                            <_accounttap Getdata={this.Getdata}
                                p3_1={this.state.sPersontype}
                                p3_2={this.state.sCreditflag}
                                p3_3={this.state.sCreditcode}
                                p3_4={this.state.sCreditshare}
                                p3_5={this.state.Accounttext}
                                p3_6={this.state.sTAXID}
                                p3_7={this.state.sAr_remark1}
                                typeTaxnumber={e => this.setState({ typeTaxnumberdefaultvalue: e })} />
                        </TabPanel>
                    </TabContext>
                </Box>



                <Snackbar place="br"
                    color={this.state.color}
                    icon={this.state.icon}
                    autoClose={this.state.autoClose}
                    message={this.state.messagealert}
                    open={this.state.opensnackbar}
                    closeNotification={() => { this.setState({ opensnackbar: false }) }}
                    close />
                {/* <Confirmdialog open={this.state.open}
                    closedialog={e => this.setState({ open: e })}
                    data={e => this.setData(e)}
                    title=""
                    description={this.state.description}
                    Agreetxt={this.state.Agreetxt}
                    Disagreetxt={this.state.Disagreetxt}
                /> */}
            </div>
        )
    }
}
